import React, { FunctionComponent } from 'react';
import { OktaScopes, OktaScopesConfig } from '../../core/okta-auth-api.consts';
import { track, TrackedEvent } from '../../core/analytics';
import './dashboard-app-buttons.scss';

interface Props {
  displayedOktaScopes: OktaScopes[];
  requestedOktaScope: OktaScopes;
  setRequestedOktaScope: (oktaScope: OktaScopes) => void;
}

const DashboardAppButtons: FunctionComponent<Props> = ({
  displayedOktaScopes,
  requestedOktaScope,
  setRequestedOktaScope,
}) => {
  const handleAppClick = (oktaScope: OktaScopes) => {
    setRequestedOktaScope(oktaScope);
    track(TrackedEvent.apiAccessSelectedAppChanged, { value: oktaScope });
  };

  return (
    <React.Fragment>
      {displayedOktaScopes.map((oktaScope) => {
        const Icon = OktaScopesConfig[oktaScope].icon;
        return (
          <div
            key={oktaScope}
            className={`app-button ${requestedOktaScope === oktaScope ? 'selected' : ''}`}
            onClick={() => {
              handleAppClick(oktaScope);
            }}
          >
            <Icon />
            <span>{OktaScopesConfig[oktaScope].title}</span>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default DashboardAppButtons;
